import { Source, Layer } from 'react-map-gl';
import { COLOR } from '../styles';
import { sourceProps } from './source-utils';

/**
 * Macroalineamiento eléctrico del proyecto — traza LAAT 115 kV entregada por
 * Elawan ingeniería (2026-06-10, ~6.6 km desde el AOI San Pedro al punto de
 * interconexión al sur). Fuente: data/final/macroalineamiento.geojson,
 * generado por services/geo/scripts/build_macroalineamiento.py desde el KMZ
 * oficial. Antes de esa fecha el GeoJSON era placeholder vacío (la capa
 * montaba sin dibujar nada) — el render es idéntico, solo cambió el dato.
 */
export function MacroalineamientoLayer({ url }: { url: string }) {
  return (
    <Source id="macroalineamiento" {...sourceProps(url)}>
      <Layer
        id="macroalineamiento-casing"
        type="line"
        paint={{ 'line-color': 'rgba(0,0,0,0.60)', 'line-width': 10, 'line-opacity': 0.60 }}
      />
      <Layer
        id="macroalineamiento-line"
        type="line"
        paint={{ 'line-color': COLOR.orange, 'line-width': 5, 'line-opacity': 1, 'line-dasharray': [8, 3] }}
      />
    </Source>
  );
}
